import { createSelector } from 'reselect'
// import { List } from 'immutable'

const accountingSelector = state => state.get('accounting')

export const getIsFetching = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.billingList.isFetching
    || accounting.billingGet.isFetching
    || accounting.billingUpdate.isFetching
    || accounting.billingExport.isFetching
    || accounting.payingList.isFetching
    || accounting.payingGet.isFetching
    || accounting.payingUpdate.isFetching
    || accounting.payingExport.isFetching
  }
)

export const getBillings = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.billingList.accountantBillings || []
  }
)

export const getBillingData = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.billingGet.accountantBilling
  }
)

export const getUpdatedBilling = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.billingUpdate || {}
  }
)

export const getBillingExportURL = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.billingExport.url
  }
)

export const getPayings = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.payingList.accountantPayings || []
  }
)

export const getPayingData = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.payingGet.accountantPaying
  }
)

export const getUpdatedPaying = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.payingUpdate || {}
  }
)

export const getPayingExportURL = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.payingExport.url
  }
)

export const getAccounting = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.accounting || {}
  }
)

export const getKeywordSearch = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.accounting.keywordSearch
  }
)

export const getAPFilter = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.accounting.apFilter
  }
)

export const getARFilter = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.accounting.arFilter
  }
)

export const isOpenManual = createSelector(
  accountingSelector,
  accountingImmutable => {
    const accounting = accountingImmutable.toJS()
    return accounting.accountingManual.isOpen
  }
)



// WEBPACK FOOTER //
// ./src/selectors/accounting-dashboard/accounting-selector.js